import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Card, CardBody, CardHeader } from 'reactstrap';
import ReviewStars from './ReviewStars';
import { textOrDash } from './CustomerReviewCreate.helpers';
import {
  ITEM_CONDITION_LABELS,
  NO_WRITTEN_REVIEW_TEXT,
} from './CustomerReviewDetail.helpers';
import styles from './CustomerReviewDetail.module.css';

const ReviewCard = ({ reviewId, review, outcome }) => {
  const rating = review.rating || 0;
  const hasWrittenReview = Boolean(review.review_text);
  const images = Array.isArray(review.images) ? review.images : [];

  return (
    <Card>
      <CardHeader className={styles.cardHeader}>REVIEW #{reviewId}</CardHeader>
      <CardBody className={styles.cardBody}>
        {outcome && (
          <Alert
            className={styles.outcomeAlert}
            color={outcome.color}
            isOpen
            toggle={outcome.onDismiss}
          >
            {outcome.message}
          </Alert>
        )}
        <div className={styles.ratingRow}>
          <ReviewStars value={rating} />
          <span className={styles.ratingText}>{rating} of 5</span>
        </div>
        <div className={styles.kvRow}>
          <span className={styles.kvLabel}>Display name</span>
          <span className={styles.kvValue}>{textOrDash(review.display_name)}</span>
        </div>
        <div className={styles.kvRow}>
          <span className={styles.kvLabel}>Item condition</span>
          <span className={styles.kvValue}>
            {textOrDash(ITEM_CONDITION_LABELS[review.item_condition])}
          </span>
        </div>
        {hasWrittenReview ? (
          <p className={styles.reviewText}>{review.review_text}</p>
        ) : (
          <p className={styles.mutedText}>{NO_WRITTEN_REVIEW_TEXT}</p>
        )}
        {images.length > 0 ? (
          <React.Fragment>
            <p className={styles.imagesLabel}>Images</p>
            <div className={styles.imageGrid}>
              {images.map((imageUrl, index) => (
                <a
                  className={styles.imageTile}
                  href={imageUrl}
                  key={imageUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img alt={`Review attachment ${index + 1}`} src={imageUrl} />
                </a>
              ))}
            </div>
          </React.Fragment>
        ) : (
          <Alert className="mb-0 text-center" color="danger">
            <strong>Ooops.. </strong>No Images Found!
          </Alert>
        )}
      </CardBody>
    </Card>
  );
};

ReviewCard.propTypes = {
  outcome: PropTypes.shape({
    color: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onDismiss: PropTypes.func,
  }),
  reviewId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  review: PropTypes.shape({
    rating: PropTypes.number,
    review_text: PropTypes.string,
    display_name: PropTypes.string,
    item_condition: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default ReviewCard;
